import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actionToggleSidePanel } from 'modules/SidePanel/store/actions'
import { selectSidePanelActiveId } from 'modules/SidePanel/store/selectors'

export const useSidePanel = () => {
  const dispatch = useDispatch()
  const activeId = useSelector(selectSidePanelActiveId)

  const toggle = useCallback((id) => dispatch(actionToggleSidePanel(id)), [dispatch])

  return {
    activeId,
    toggle,
  }
}
